import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const RouteChangeTracker = () => {
  const location = useLocation();
  const userData = useSelector((state) => state.auth.userInfo); // <--- acceso correcto

  useEffect(() => {
    if (!userData) return;

    const page = location.pathname;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'user_navigation',
      page,
      datetime: new Date().toISOString(),
      userId: userData.userId,
      laboratory: userData.enterpriseKey
    });
  }, [location, userData]); // dependencias actualizadas

  return null;
};

export default RouteChangeTracker;
